import { useAppSelector } from "@/redux/hooks";
import { useSplitClient } from "@splitsoftware/splitio-react";

export const useAsyncCheckoutEnabled = () => {
  const userProfile = useAppSelector((state) => state.userProfile);
  const splitIO = useSplitClient();
  const syncOptionForRetailerTreatment = splitIO.client?.getTreatment(
    "brandclub_async_checkout",
    { email: userProfile?.email ?? "" }
  ) as "on" | "off" | "debug";

  return {
    enabled: ["on", "debug"].includes(syncOptionForRetailerTreatment),
    debug: syncOptionForRetailerTreatment === "debug",
  };
};
